export default __webpack_public_path__ + "img/Cinnamomum_burmannii.91f57e37.jpg";